import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { WhyUsSection } from '../components/WhyUsSection';
import { PricingCard } from '../components/PricingCard';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
export function LandingPage() {
  return <main className="min-h-screen bg-brand-black text-white selection:bg-brand-gold selection:text-brand-black" data-id="element-158">
      <HeroSection data-id="element-159" />
      <TrustBar data-id="element-160" />
      <WhyUsSection data-id="element-161" />
      <PricingCard data-id="element-162" />
      <FAQSection data-id="element-163" />
      <Footer data-id="element-164" />
      <WhatsAppButton data-id="element-165" />
    </main>;
}